<template>
  <DBox
    :id="'cmp-contacts-contacts-bank-details2'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_bank_details')}`"
    @add_click="onAddBankDetails"
  >
    <!-- <div class="accordion-container">
      <div class="accordion-item">
        <div class="accordion-item-header">

        </div>
        <div class="accordion-item-body"></div>
      </div>
      :class="{ open: active_el == paymentProvider.providerName }"
    </div> -->
    <div class="accordion-container">
      <div
        v-for="(paymentProvider, index) in filteredPayment_provider_data"
        :index="index"
        :key="paymentProvider.providerName"
        :class="[
          'accordion-item',
          { 'is-open': isOpen.includes(paymentProvider.providerName) },
        ]"
      >
        <div class="accordion-item-header">
          <a
            class="list-heading"
            @click="editOpenDialog(paymentProvider.providerName)"
            >{{ $dft.snakeCaseToWords(paymentProvider.providerName) }}
          </a>
          <div class="border" @click="toggleOpen(paymentProvider.providerName)">
            <img
              src="static/icons/minus.svg"
              alt
              class="dt-icon v6 s1 h0 minus"
            />
            <img
              src="static/icons/plus.svg"
              alt
              class="dt-icon v6 s1 h0 plus"
            />
          </div>
          <img
            src="static/icons/delete.svg"
            alt
            class="dt-icon v5 s1 delete-icon"
            @click.stop="(e) => onDeleteProvider(paymentProvider)"
          />
        </div>

        <div class="accordion-item-body" @click.stop="">
          <ul
            class="list-panel"
            v-if="paymentProvider.providerName === 'iban_banking'"
          >
            <li>
              <span class="label">{{ $t('account_holder') }}</span>
              <span class="value">{{ paymentProvider.account_holder }}</span>
            </li>
            <li>
              <span class="label">{{ $t('bank_name') }}</span>
              <span class="value">{{ paymentProvider.bank_name }}</span>
            </li>
            <li>
              <span class="label">{{'iban'}}</span>
              <span class="value">{{ paymentProvider.iban }}</span>
            </li>
            <li>
              <span class="label">{{$t('bic')}}</span>
              <span class="value">{{ paymentProvider.bic }}</span>
            </li>
            <li>
              <span class="label">{{ $t('notes') }}</span>
              <span class="value">{{ paymentProvider.notes }}</span>
            </li>
          </ul>

          <ul
            class="list-panel"
            v-if="paymentProvider.providerName === 'classic_banking'"
          >
            <li>
              <span class="label">{{$t('account_holder')}}</span>
              <span class="value">{{ paymentProvider.account_holder }}</span>
            </li>
            <li>
              <span class="label">{{ $t('account_no') }}</span>
              <span class="value">{{ paymentProvider.account_no }}</span>
            </li>
            <li>
              <span class="label">{{$t('bank_name')}}</span>
              <span class="value">{{ paymentProvider.bank_name }}</span>
            </li>
            <li>
              <span class="label">{{$t('sort_code')}}</span>
              <span class="value">{{ paymentProvider.sortcode }}</span>
            </li>
          </ul>

          <ul
            class="list-panel"
            v-if="paymentProvider.providerName === 'international_bank_infos'"
          >
            <li>
              <span class="label">{{$t('account_holder')}}</span>
              <span class="value">{{ paymentProvider.account_holder }}</span>
            </li>
            <li>
              <span class="label">{{$t('bank_name')}}</span>
              <span class="value">{{ paymentProvider.bank_name }}</span>
            </li>
            <li>
              <span class="label">{{ $t('account_no') }}</span>
              <span class="value">{{ paymentProvider.account_no }}</span>
            </li>
            <li>
              <span class="label">{{$t('bank_address1')}}</span>
              <span class="value">{{ paymentProvider.bank_address1 }}</span>
            </li>
            <li>
              <span class="label">{{ $t('bank_routing') }}</span>
              <span class="value">{{ paymentProvider.bank_routing }}</span>
            </li>
            <li>
              <span class="label">{{ $t('bank_address2') }}</span>
              <span class="value">{{ paymentProvider.bank_address2 }}</span>
            </li>
            <li>
              <span class="label">{{'iban'}}</span>
              <span class="value">{{ paymentProvider.iban }}</span>
            </li>
            <li>
              <span class="label">{{ $t('bank_city') }}</span>
              <span class="value">{{ paymentProvider.bank_city }}</span>
            </li>
            <li>
              <span class="label">{{$t('bic')}}</span>
              <span class="value">{{ paymentProvider.bic }}</span>
            </li>
            <li>
              <span class="label">{{ $t('bank_postalcode') }}</span>
              <span class="value">{{ paymentProvider.bank_postalcode }}</span>
            </li>
            <li>
              <span class="label">{{ $t('intermediate_bank') }}</span>
              <span class="value">{{ paymentProvider.intermediate_bank }}</span>
            </li>
            <li>
              <span class="label">{{ $t('bank_country') }}</span>
              <span class="value">{{ paymentProvider.bank_country }}</span>
            </li>
            <li>
              <span class="label">{{ $t('intermediate_country') }}</span>
              <span class="value">{{
                paymentProvider.intermediate_country
              }}</span>
            </li>
          </ul>

          <ul
            class="list-panel"
            v-if="
              paymentProvider.providerName === 'paypal' ||
              paymentProvider.providerName === 'Paypal'
            "
          >
            <li>
              <span class="label">{{ $t('paypal_email') }}</span>
              <span class="value">{{ paymentProvider.paypal_email }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { ContactsService } from "../../services/contacts.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  props: ["accountingInfo", "selectedContactId"],
  components: {
    DBox,
  },
  data() {
    return {
      active_el: "",
      isOpen: [],
    };
  },
  computed: {
    filteredPayment_provider_data: function () {
      return this.payment_provider_data.filter(
        (e) => e.providerName && e.providerName.length > 0
      );
    },
    payment_provider_data: function () {
      const payment_provider_data = this.accountingInfo.payment_provider_data;
      return Object.keys(payment_provider_data).map((providerName) => {
        return {
          providerName,
          ...payment_provider_data[providerName],
        };
      });
    },
  },
  methods: {
    toggleOpen: function (el) {
      console.log("Log: el", el);
      console.log("Log: this.active_el", this.active_el);
      // if (this.active_el == el) {
      //   this.active_el = "";
      // } else {
      //   this.active_el = el;
      // }
      if (this.isOpen.includes(el)) {
        this.isOpen = this.isOpen.filter((i) => i !== el);
        return;
      }

      this.isOpen.push(el);
    },
    onAddBankDetails() {
      this.$emit("add_click", true);
    },
    editOpenDialog(paymentProviderName) {
      this.$emit("editOpenDialog", paymentProviderName);
    },
    async onDeleteProvider(paymentProvider) {
      const { providerName } = paymentProvider;
      const confirmationResult = await confirmDelete(
        "Bank Details",
        providerName
      );
      if (confirmationResult === "OK") {
        await ContactsService.removeBankDetails(
          this.selectedContactId,
          providerName
        );
        this.$emit("delete", {
          selectedContactId: this.selectedContactId,
          providerName,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-heading {
  display: inline-block;
  font-size: 13px;
  line-height: 30px;
  padding: 0 10px;
  color: var(--text-primary);
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    text-decoration: underline;
  }
}
.list-panel {
  display: flex;
  flex-direction: column;
  list-style: none;
  li {
    display: flex;
    flex: 1;
    line-height: 30px;
    border-bottom: 1px solid var(--sprt-85);
  }

  .label,
  .value {
    padding: 0 10px;
    overflow: hidden;
    word-wrap: break-word;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .label {
    flex: 1;
    max-width: 135px;
    color: var(--text-5);
    font-weight: 400;
  }
  .value {
    flex: 2;
    color: var(--text-primary);
  }
}

.accordion-item {
  // margin-bottom: 2px;
  .accordion-item-header {
    border-bottom: 1px solid var(--sprt-85);
    padding-right: 5px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    .border {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 30px;
      position: absolute;
      right: 35px;
      top: 0;
      border-left: 1px solid var(--sprt-85);
      border-right: 1px solid var(--sprt-85);
      .dt-icon {
        display: none;
        cursor: pointer;

        &.plus {
          display: block;
        }
      }
    }
    .delete-icon {
      position: absolute;
      top: 3px;
      right: 5px;
    }
  }
  .accordion-item-body {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease;

    .row {
      align-items: center;
      border-bottom: 1px solid #c8c8c8;
    }
  }

  &.is-open {
    .accordion-item-header {
      .dt-icon {
        &.minus {
          display: block;
        }
        &.plus {
          display: none;
        }
      }
    }
    .accordion-item-body {
      opacity: 1;
      max-height: 1000px;
    }
  }
}
</style>
